import { render, staticRenderFns } from "./ThumbnailImage.vue?vue&type=template&id=4bc045d0&scoped=true&"
import script from "./ThumbnailImage.vue?vue&type=script&lang=js&"
export * from "./ThumbnailImage.vue?vue&type=script&lang=js&"
import style0 from "./ThumbnailImage.vue?vue&type=style&index=0&id=4bc045d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc045d0",
  null
  
)

export default component.exports